webpackJsonp([142629428675168],{

/***/ 771:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"languages":{"defaultLangKey":"es","langs":["es","en"]}}}},"pathContext":{"slug":"/","langKey":"es"}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-cf8457bdcbe4971f5643.js